/**
 * top-page-only.js
 * 要件：
 *  - 初回ロード時はエラー非表示
 *  - 「カートに追加」「Shop Pay」どちらも常に押せる
 *  - 押下/送信の瞬間にのみ検証し、未同意ならその操作を中断してエラー表示
 *  - 同意後は Shop Pay へ直接進行可能（ポインタイベントの無効化等は行わない）
 */
(function () {
  'use strict';

  // --- 設定 ---
  var GROOVY_CONTAINER_SELECTOR = '.groovyco-form-generated';
  var REQUIRED_LABEL_KEYWORD = '（必須）';
  var PER_ITEM_ERROR_TEXT = 'この項目にチェックを入れてください。';
  var GLOBAL_ERROR_TEXT = '必須項目への同意チェックが未選択です。すべての「（必須）」にチェックを入れてください。';

  // --- util ---
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function setGlobalError(form, message) {
    var pf = form.closest('.product-form');
    if (!pf) return;
    var wrapper = pf.querySelector('.product-form__error-message-wrapper');
    var label = pf.querySelector('.product-form__error-message');
    if (!wrapper || !label) return;
    if (message) {
      label.textContent = message;
      wrapper.hidden = false;
    } else {
      label.textContent = '';
      wrapper.hidden = true;
    }
  }

  function findGroovyContainerFor(form) {
    var scope = form.closest('section, .section, main, body') || document;
    return scope.querySelector(GROOVY_CONTAINER_SELECTOR) || document.querySelector(GROOVY_CONTAINER_SELECTOR);
  }

  // showErrors=false のときは一切メッセージを書かない
  function renderItemErrors(invalidItems, showErrors) {
    if (!showErrors) return;
    invalidItems.forEach(function (item) {
      var keyNormalized = item.labelText.replace(/\s+/g, '');
      var errEl =
        item.el.querySelector('.groovyco-error[data-key="' + keyNormalized + '"]') ||
        item.el.querySelector('.groovyco-error[data-key]') ||
        item.el.querySelector('.groovyco-error');
      if (errEl) errEl.textContent = PER_ITEM_ERROR_TEXT;
    });
  }

  function clearItemErrors(container) {
    if (!container) return;
    $all('.groovyco-error', container).forEach(function (el) { el.textContent = ''; });
  }

  /**
   * 同意チェック検証
   * @param {HTMLFormElement} form
   * @param {boolean} showErrors  この呼び出しで可視エラーを出すか
   */
  function validateGroovyChecks(form, showErrors) {
    var container = findGroovyContainerFor(form);
    if (!container) return { ok: true, invalidItems: [] };

    // 画面上にエラーを出すときだけ、出力前にクリア
    if (showErrors) clearItemErrors(container);

    var checkboxes = $all('.groovyco-element.groovyco-checkbox input[type="checkbox"]', container);
    var invalid = [];

    checkboxes.forEach(function (input) {
      var el = input.closest('.groovyco-element.groovyco-checkbox');
      if (!el) return;
      var labelEl = el.querySelector('label');
      var labelText = (labelEl && labelEl.innerText ? labelEl.innerText : '').trim();
      var isRequired = labelText.indexOf(REQUIRED_LABEL_KEYWORD) !== -1;
      if (isRequired && !input.checked) {
        invalid.push({ input: input, el: el, labelText: labelText });
      }
    });

    renderItemErrors(invalid, showErrors);
    return { ok: invalid.length === 0, invalidItems: invalid };
  }

  function focusFirstInvalid(invalidItems) {
    if (!invalidItems.length) return;
    var el = invalidItems[0].el;
    var input = invalidItems[0].input;
    (el || input).scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { input && input.focus && input.focus({ preventScroll: true }); } catch (_) {}
  }

  // フォームごとに「ユーザーが一度でも操作したか」を記録（初期は未操作＝エラー非表示）
  function markInteracted(form) {
    form.dataset.gcInteracted = '1';
  }
  function hasInteracted(form) {
    return form.dataset.gcInteracted === '1';
  }

  // --- イベントガード ---
  // 1) 送信（Enterキー含む）をキャプチャで先取り
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('.product-form')) return;

    markInteracted(form); // 初回インタラクションとして扱う
    var result = validateGroovyChecks(form, /*showErrors=*/true);
    if (!result.ok) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      setGlobalError(form, GLOBAL_ERROR_TEXT);
      focusFirstInvalid(result.invalidItems);
    } else {
      setGlobalError(form, '');
    }
  }, true); // capture:true

  // 2) クリック（「カートに追加」「Shop Pay」両方）をキャプチャで先取り
  document.addEventListener('click', function (e) {
    var target = e.target;
    var buttonsWrap = target && target.closest && target.closest('.product-form__buttons');
    if (!buttonsWrap) return;

    var pf = buttonsWrap.closest('.product-form');
    var form = pf && pf.querySelector('form');
    if (!form) return;

    // 「カートに追加」か「.shopify-payment-button」内のクリックのみ対象
    var isSubmitBtn = !!(target.closest('button[type="submit"]'));
    var isAcceleratedArea = !!(target.closest('.shopify-payment-button'));
    if (!isSubmitBtn && !isAcceleratedArea) return;

    markInteracted(form);
    var result = validateGroovyChecks(form, /*showErrors=*/true);
    if (!result.ok) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      setGlobalError(form, GLOBAL_ERROR_TEXT);
      focusFirstInvalid(result.invalidItems);
    } else {
      setGlobalError(form, '');
      // 有効時は何も抑止しない（Shop Payへ直接進行可）
    }
  }, true); // capture:true

  // 3) 入力変化：チェックが変わったら、既にインタラクション済みのときだけエラーを更新（初期表示では無反応）
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.type !== 'checkbox') return;
    var form = target.closest('.product-form form');
    if (!form) return;

    if (hasInteracted(form)) {
      // 再評価して問題なければ全体エラーを消す（個別エラーも含め validate 内で更新）
      var result = validateGroovyChecks(form, /*showErrors=*/true);
      if (result.ok) setGlobalError(form, '');
    } else {
      // 未インタラクション時は何も表示しない
    }
  });

  // --- 初期化：初回ロード時はエラー非表示・評価もしない（状態はユーザー操作時にのみ評価） ---
  // 何も行わない（バリデーションは最初の click/submit/change まで待つ）
})();
